'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scrollbar = require('./scrollbar');

var _scrollbar2 = _interopRequireDefault(_scrollbar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _scrollbar2.default;
module.exports = exports['default'];